//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE } from '@/scripts/constants/media-query'
export default {
  name: 'rb-holiday-wrapper',
  props: {
    backgroundColor: {
      type: String,
      default: 'white', // options: ['white', 'dark']
    },
  },
  computed: {
    dynamicVariants() {
      return {
        'rb-holiday-wrapper__banners--2-elements': this.numberOfBanners === 2,
        'rb-holiday-wrapper__banners--3-elements': this.numberOfBanners === 3,
        'rb-holiday-wrapper__banners--4-elements': this.numberOfBanners === 4,
        'rb-holiday-wrapper__banners--with-carousel': this.numberOfBanners > 4,
      }
    },
    numberOfBanners() {
      return this.$slots.banners.filter((slot) => slot.tag).length
    },
    isMobile() {
      return this.$mq === MOBILE
    },
    columnsOfNextSlide() {
      return this.isMobile ? 2 : 0
    },
    getSpaceBetweenSlides() {
      return this.isMobile ? 8 : 16
    },
    isPaginationVisible() {
      return this.isMobile && this.numberOfBanners > 2
    },
    swiperNavigationColor() {
      return this.backgroundColor === 'white' ? 'dark' : 'light'
    },
  },
}
